export default __webpack_public_path__ + "static/media/lines.cfb8e2d3.svg";